import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import EventCalendar from './EventCalendar';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Attendance2(props) {
  return (
    <>
      <EventCalendar {...props} />
    </>
  );
}